/*@ngInject*/
const BaseFormComponentController = function ($scope, $rootScope, formComponentUtil, formViewerConstant, formMediator, coreConstant, formatUtil) {

    this.onInit = function () {
        const fieldInstance = this.fieldStructure.fieldModel;
        this.hideLabel = _.isNil(this.fieldStructure.hideLabel) ? this.hideLabel : this.fieldStructure.hideLabel;

        this.origFieldValue = fieldInstance ? fieldInstance.value : '';
        this.configurationClass = this.fieldStructure.isConfigurableComponent ? 'configurableComponent' : '';
    };

    this.onChanges = function () {
        const fieldInstance = this.fieldStructure.fieldModel;
        const hasValueChange = fieldInstance ? this.origFieldValue !== fieldInstance.value : false;

        this.hideLabel = _.isNil(this.fieldStructure.hideLabel) ? this.hideLabel : this.fieldStructure.hideLabel;
        if (!this.fieldStructure.hasLocalChanges && hasValueChange) {
            $scope.$broadcast(formViewerConstant.event.SHOW_REMOTE_FIELD_NOTIFICATION);
        }
        this.origFieldValue = fieldInstance ? fieldInstance.value : '';
        this.fieldStructure.hasLocalChanges = false;
    };

    this.updateOriginalFieldValue = function () {
        this.origFieldValue = this.fieldStructure.fieldModel.value;
    };

    this.resetFieldValue = function () {
        this.fieldStructure.fieldModel.value = this.origFieldValue;
    };

    this.getComponentClassName = function (uiField) {
        return `formFieldComponent-${formatUtil.formatAsSelector(uiField.fieldTemplate.variableName)}`;
    };

    this.getComponentId = function (uiField) {
        return uiField.fieldTemplate.variableName;
    };

    this.updateFieldValue = function () {
        if (this.fieldStructure.hasLocalChanges) {
            formMediator.handleFieldChange(this.fieldStructure.parentForm.id, this.fieldStructure, this.resetFieldValue.bind(this), this.updateOriginalFieldValue.bind(this));
        }
    };

    this.handleFocus = function () {
        $rootScope.$broadcast(formViewerConstant.event.FOCUSED_FIELD_CHANGED, this.fieldStructure);
    };

    this.mouseEnter = function (event, fieldStructure) {
        const componentParams = {
            pageX: event.pageX,
            pageY: event.pageY,
            offsetX: event.offsetX,
            offsetY: event.offsetY,
            clientWidth: event.currentTarget.clientWidth,
            fieldStructure: fieldStructure,
            tooltipMessage: fieldStructure.uiField.tooltipText
        };
        if (!_.isNil(fieldStructure.dynamicProperties.tooltip) && !_.isNil(fieldStructure.dynamicProperties.tooltip.message)) {
            componentParams.tooltipMessage = fieldStructure.dynamicProperties.tooltip.message;
        }

        if (!_.isNil(componentParams.tooltipMessage)) {
            $rootScope.$broadcast(coreConstant.event.SHOW_FORM_TOOLTIP, componentParams);
        }
    };

    this.mouseLeave = function () {
        $rootScope.$broadcast(coreConstant.event.HIDE_FORM_TOOLTIP);
    };
};

angular.module('umFormViewer')
    .controller('baseFormComponentController', BaseFormComponentController);
